import Component from '@glimmer/component';
import type { CustomFieldSignature } from '../../types/tuition-assistance.ts';

export interface TuitionAssistanceProgramCustomReadonlyFieldSignature {
  Args: {
    customField: CustomFieldSignature;
  };
  Blocks: {
    default: [
      {
        isVisible: boolean;
        isRequired: boolean;
        programLabel: string;
        value: unknown;
        rawField: CustomFieldSignature;
      },
    ];
  };
}

export default class TuitionAssistanceProgramCustomReadonlyFieldComponent extends Component<TuitionAssistanceProgramCustomReadonlyFieldSignature> {
  get formattedValue() {
    const field = this.args.customField;
    const rawValues = field?.values || [];

    if (rawValues.length > 1) {
      // If value is an array with multiple items, return it. The value is meant to be an array.
      return rawValues.map(this.formatValueIfApplicable);
    }

    // Otherwise we can assume the value is the single item in the array.
    const singleValue = rawValues[0];

    return this.formatValueIfApplicable(singleValue);
  }

  formatValueIfApplicable(value: unknown) {
    const options = this.args.customField?.options || [];
    const match = options.find((option: unknown) => {
      // @ts-expect-error TODO type field
      return option.value === value;
    });
    return match?.label || value;
  }

  <template>
    {{#let
      (hash
        isVisible=@customField.visible
        isRequired=@customField.required
        programLabel=@customField.label
        formattedValue=this.formattedValue
      )
      as |config|
    }}
      {{#if config.isVisible}}
        {{yield
          (hash
            isVisible=config.isVisible
            isRequired=config.isRequired
            programLabel=config.programLabel
            value=config.formattedValue
            rawField=@customField
          )
        }}
      {{/if}}
    {{/let}}
  </template>
}
